import { render, staticRenderFns } from "./CvCard.vue?vue&type=template&id=e28a44f6&"
import script from "./CvCard.vue?vue&type=script&lang=js&"
export * from "./CvCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports